var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgField2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 56,
    viewBox: "0 0 1280 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H1264C1272.84 0 1280 7.16344 1280 16V40C1280 48.8366 1272.84 56 1264 56H16C7.16343 56 0 48.8366 0 40V16Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1134,
    y: 16,
    width: 122,
    height: 24,
    rx: 8,
    fill: "#F3F3F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 970,
    y: 16,
    width: 132,
    height: 24,
    rx: 8,
    fill: "#F3F3F3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 16,
    width: 280,
    height: 24,
    rx: 8,
    fill: "#F3F3F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 16,
    width: 156,
    height: 24,
    rx: 8,
    fill: "#F3F3F3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 16,
    width: 96,
    height: 24,
    rx: 8,
    fill: "#F3F3F3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 16,
    width: 48,
    height: 24,
    rx: 8,
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgField2);
export default __webpack_public_path__ + "static/media/Field2.8972ccb98787d72ccfe9bdd4bedd357f.svg";
export { ForwardRef as ReactComponent };